

























import { Vue, Component, Prop } from 'vue-property-decorator';
import Api from '@/project/http/Api.service';
import { BrandsBlockViewModel } from '@/types/contentServerContract';
import { CustomerBrandTileViewObject } from '@/types/apiServerContract';
import categoryUrlService from '@/project/shared/category.service';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import { PageName } from '@/router/routes/constants';
import authService from '@/core/auth/auth.service';

@Component({
    components: { SmartHeadline }
})
export default class BrandsBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: BrandsBlockViewModel;

    @Prop({
        required: true,
        type: Boolean
    }) isFirstBlock!: boolean;

    isLoading: boolean = true;

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    private brands: CustomerBrandTileViewObject[] = [];

    private get brandPageName() {
        return PageName.BRAND;
    }

    private get brandOverviewPageName() {
        return PageName.BRAND_OVERVIEW;
    }

    private async getBrandTiles() {
        const categoryIdFromUrl = categoryUrlService.getCategoryIdFromUrl(this.$route.path);
        const result = await Api.customer.brandTiles(categoryIdFromUrl);
        this.brands = result.brandTiles;
        this.isLoading = false;
    }

    get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    created() {
        this.getBrandTiles();
    }
}
